import React, {useEffect, useState} from "react";
import {Button, Layout} from "antd";
import {Link, NavLink, useParams} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {basePath, PATH} from "../../config";
import { redirectTo } from "../../config/CoreMethods";
import {useSelector} from "react-redux";
import {ROUTES as ROUTES_CONFIG} from "../../config/constants";
import axiosData from "../../helpers/axiosData";
import { fetchUser } from "../../redux/features/userSlice";

const { Content } = Layout

const ApproveEmail = () => {

    const [UserData, setUserData] = useState({})
    let { hash } = useParams();

    const fetchUserData = async (dispatch, getState) => {
        try {
            await dispatch(fetchUser())
        } catch (error) {
            console.log('fetchUser error', error)
        } 
    };

    
    const sendApproveEmailword = (hash) => {

        if (typeof hash == 'string' && /^([a-z0-9]{44,46})$/.test(hash) ) {
            
            axiosData.post("/api/_web3/user/activate/", {hash: hash}).then((res) => {

                if (res.data.success) {
                    
                    fetchUserData()
                    toast.success('Your account successfully approved!');
                    
                } else {
                    toast.error('OOPS! Something went wrong.')
                }
            })
        } else {
            toast.error('OOPS! Type Valid Data')
        }

    }


    useEffect(()=>{
        sendApproveEmailword(hash)
    },[hash])

    return (
        <div className="min-h-calc-head h-full flex items-center justify-center" style={{paddingTop: "92px", background: `url(${PATH + 'bg-auth.png'}) center center / cover`}}>
            <div className="container mx-auto">
                <Layout className="bg-transparent h-full">
                    <Content className="pt-4 pb-4 pl-14 pr-14 xs-p-2">
                        <div className="flex flex-col items-center gap-y-5">

                            <div className="login-note">
                                Please make sure you are visiting
                                <div>
                                    <i className="icon-lock-closed text-green-400 mr-1"></i>
                                    <span className="text-green-400"> https://</span>app.metafluence.com
                                </div>
                            </div>
                            
                            <ToastContainer />
                            <div className="flex justify-center">
                                <div className="login-form form-box">
                                    <div className="text-center">
                                        <i className="icon-check text-cyan-400 text-5xl"></i>
                                        <h1 className="text-white font-normal text-2xl mt-4 mb-4">Verified!</h1>
                                        <p className="text-sm text-gray-300">You have successfully verified your email.</p>
                                    </div>
                                    <div className="flex justify-center mt-7 mb-6">
                                        <NavLink to={ROUTES_CONFIG.loginPage.path}>
                                            <Button type="submit"  className="border-0 bg-cyan-500 text-indigo-900 hover:bg-cyan-400 rounded-3xl font-medium text-base login-btn flex items-center justify-center gap-x-3">
                                                Go to Login
                                            </Button>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                             
                        </div>
                    </Content>
                </Layout>
            </div>
        </div>
    )
}

export default ApproveEmail;